import { gql } from "@apollo/client";

export const getDailyDealProducts = gql`
  query getDailyDealProducts(
    $titleInclude: [String!]
    $titleExclude: [String!]
    $campaignTypes: [String!]
    $retailPrice: [RangeFilter!]
    $reviewsRating: RangeFilter
    $reviewsCount: RangeFilter
    $brandIds: [Float!]
    $departmentIds: [Float!]
    $categoryIds: [Float!]
    $subCategoryIds: [Float!]
    $retailerIds: [Float!]
    $isBrandClubReady: Boolean
    $totalRewardAmount: RangeFilter
    $page: PageFilter
    $sort: [SortFilter!]
    $facetFieldNames: [String!]
    $computeFacets: Boolean
    $applySpellingCheck: Boolean
  ) {
    DailyDealProducts(
      titleInclude: $titleInclude
      titleExclude: $titleExclude
      campaignTypes: $campaignTypes
      retailPrice: $retailPrice
      reviewsRating: $reviewsRating
      totalRewardAmount: $totalRewardAmount
      reviewsCount: $reviewsCount
      brandIds: $brandIds
      categoryIds: $categoryIds
      departmentIds: $departmentIds
      subCategoryIds: $subCategoryIds
      retailerIds: $retailerIds
      isBrandClubReady: $isBrandClubReady
      page: $page
      sort: $sort
      facetFieldNames: $facetFieldNames
      computeFacets: $computeFacets
      applySpellingCheck: $applySpellingCheck
    ) {
      items {
        stacklineSku
        title
        brandId
        brandName
        retailerSku
        retailPrice
        imageUrls
        retailerId
        hasActiveInstantReward
        affiliateRewardAmount
        totalRewardAmount
        scores {
          maxPurchaseRewardPercent
          maxPurchaseRewardAmount
          maxAffiliateRewardPercent
          maxAffiliateRewardAmount
          totalReviewRewardFeesAmount
        }
        matchedProducts {
          retailPrice
          retailerId
        }
        campaignRewards {
          campaignId
          campaignType
          rewardAmount
          rewardAmountType
          campaignStatus
        }
        dailyDealRewardInfo {
          rewardAmount
          totalRewardCount
          availableRewardCount
          userRewardStatus
          qualifyingOrderPurchaseType
        }
      }
      hasMore
      nextPage
    }
  }
`;

export const getUnauthedDailyDealProducts = gql`
  query getDailyDealProducts(
    $titleInclude: [String!]
    $titleExclude: [String!]
    $campaignTypes: [String!]
    $retailPrice: [RangeFilter!]
    $reviewsRating: RangeFilter
    $reviewsCount: RangeFilter
    $brandIds: [Float!]
    $departmentIds: [Float!]
    $categoryIds: [Float!]
    $subCategoryIds: [Float!]
    $retailerIds: [Float!]
    $isBrandClubReady: Boolean
    $totalRewardAmount: RangeFilter
    $page: PageFilter
    $sort: [SortFilter!]
    $facetFieldNames: [String!]
    $computeFacets: Boolean
    $applySpellingCheck: Boolean
  ) {
    UnauthedDailyDealProducts(
      titleInclude: $titleInclude
      titleExclude: $titleExclude
      campaignTypes: $campaignTypes
      retailPrice: $retailPrice
      reviewsRating: $reviewsRating
      totalRewardAmount: $totalRewardAmount
      reviewsCount: $reviewsCount
      brandIds: $brandIds
      categoryIds: $categoryIds
      departmentIds: $departmentIds
      subCategoryIds: $subCategoryIds
      retailerIds: $retailerIds
      isBrandClubReady: $isBrandClubReady
      page: $page
      sort: $sort
      facetFieldNames: $facetFieldNames
      computeFacets: $computeFacets
      applySpellingCheck: $applySpellingCheck
    ) {
      items {
        stacklineSku
        title
        brandId
        brandName
        retailerSku
        retailPrice
        imageUrls
        retailerId
        hasActiveInstantReward
        affiliateRewardAmount
        totalRewardAmount
        scores {
          maxPurchaseRewardPercent
          maxPurchaseRewardAmount
          maxAffiliateRewardPercent
          maxAffiliateRewardAmount
          totalReviewRewardFeesAmount
        }
        matchedProducts {
          retailPrice
          retailerId
        }
        campaignRewards {
          campaignId
          campaignType
          rewardAmount
          rewardAmountType
          campaignStatus
        }
        dailyDealRewardInfo {
          rewardAmount
          totalRewardCount
          availableRewardCount
          userRewardStatus
          qualifyingOrderPurchaseType
        }
      }
      hasMore
      nextPage
    }
  }
`;
